import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// Models
import { ApiServer } from '@models/narobial/apiserver';

@Injectable()
export class ApiServerService {
  // Rutas.
  readonly URL_API = '/api/narobial/apisservers/';
  private protocol = 'https://';

  constructor(private http: HttpClient) {}

  // GET: Obtener api-servers
  public getApiServers(url: string): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_API + 'all');
  }

  // GET: Obtener api-server a partir del codigo de DMS.
  public getApiServersByDmsCodeId(url: string, id: string, api: any): Observable<Object> {
    return this.http.get(this.protocol + url + this.URL_API + 'apibydmscodeid/' + id + '/' + api);
  }

  // POST: Crear api-server.
  public addApiServer(url: string, apiServer: ApiServer): Observable<Object> {
    return this.http.post(this.protocol + url + this.URL_API, apiServer);
  }

  // PUT: Modificar api-server.
  public editApiServer(url: string, apiServer: ApiServer): Observable<Object> {
    return this.http.put(this.protocol + url + this.URL_API, apiServer);
  }

  // DELETE: Eliminar api-server.
  public deleteApiServer(url: string, _id: String): Observable<Object> {
    return this.http.delete(this.protocol + url + this.URL_API + `${_id}`);
  }
}
